import styled from 'styled-components';

export const StyledTable = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  backdrop-filter: blur(20px);
  background: var(--surface-2);
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid var(--border-subtle);
`;

export const StyledTableHead = styled.thead`
  background: var(--table-header-bg);
`;

export const StyledTableRow = styled.tr`
  border-bottom: 1px solid var(--border-subtle);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--text-primary);
  height: 100%;
  width: 100%;

  &:last-child {
    border-bottom: none;
  }
`;

export const StyledTableCell = styled.td`
  padding: 10px 10px;
  vertical-align: top;
  color: var(--text-primary);
  font-size: 0.8125rem;
  line-height: 1.4;
  word-wrap: break-word;
  overflow-wrap: anywhere;

  &:nth-child(1) {
    text-align: left;
    width: 15%;
  }
  &:nth-child(2) {
    text-align: center;
    width: 12%;
    white-space: nowrap;
  }
  &:nth-child(3) {
    text-align: left;
    width: 12%;
  }
  &:nth-child(4) {
    text-align: center;
    width: 10%;
  }
  &:nth-child(5) {
    text-align: left;
    width: 11%;
  }
  &:nth-child(6) {
    text-align: center;
    width: 11%;
  }
  &:nth-child(7) {
    text-align: left;
    width: 13%;
  }
  &:nth-child(8) {
    text-align: center;
    width: 16%;
    min-width: 108px;
    vertical-align: middle;
    overflow-wrap: normal;
    word-break: normal;
  }
`;

export const StyledTableHeader = styled.th`
  padding: 11px 10px;
  text-align: center;
  font-weight: var(--table-header-font-weight);
  color: var(--table-header-color);
  font-size: var(--table-header-font-size);
  text-transform: uppercase;
  letter-spacing: var(--table-header-letter-spacing);
  backdrop-filter: blur(10px);
  vertical-align: bottom;
  line-height: 1.25;
  word-wrap: break-word;

  &:nth-child(1) {
    text-align: left;
    width: 15%;
  }
  &:nth-child(2) {
    text-align: center;
    width: 12%;
  }
  &:nth-child(3) {
    text-align: left;
    width: 12%;
  }
  &:nth-child(4) {
    text-align: center;
    width: 10%;
  }
  &:nth-child(5) {
    text-align: left;
    width: 11%;
  }
  &:nth-child(6) {
    text-align: center;
    width: 11%;
  }
  &:nth-child(7) {
    text-align: left;
    width: 13%;
  }
  &:nth-child(8) {
    text-align: center;
    width: 16%;
    min-width: 108px;
  }
`;

export const StyledViewLink = styled.span`
  color: var(--text-heading);
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: var(--accent);
  }
`;

export const StyledButtonVisualizar = styled.button`
  background: var(--accent-soft);
  border: 2px solid var(--border-default);
  border-radius: 20px;
  color: var(--text-heading);
  cursor: pointer;
  display: inline-block;
  font-family: -apple-system, system-ui, Roboto, sans-serif;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 11px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: auto;
  min-width: 80px;
  height: 32px;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, var(--accent-secondary-soft) 0%, var(--accent-soft) 100%);
    opacity: 0;
    transition: opacity 0.4s ease;
    border-radius: 18px;
    z-index: 1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 18px;
    background: transparent;
    box-shadow: 0 8px 20px var(--accent-soft);
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: -1;
  }

  &:hover {
    transform: translateY(-4px);
    border-color: var(--accent);
    color: var(--text-primary);

    &::before {
      opacity: 1;
    }

    &::after {
      opacity: 1;
    }
  }

  &:active {
    transform: translateY(-2px);
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
    padding: 6px 12px;
    min-width: 70px;
    height: 28px;
  }
`;

export const DesktopOnly = styled.div`
  width: 100%;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const MobileCards = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
  }
`;

export const MobileCard = styled.article`
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  padding: 0.9rem 1rem;
  border-radius: 14px;
  border: 1px solid var(--border-default);
  background: var(--surface-2);
`;

export const MobileCardTitle = styled.h3`
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-heading);
`;

export const MobileCardMeta = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: var(--text-secondary);
  line-height: 1.4;
  word-break: break-word;
`;

export const MobileCardActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.35rem;

  button {
    flex: 1 1 auto;
    min-width: 110px;
  }
`;
